import React from "react";
import { CommonProps } from "fds/src/helpers/props";

export interface IProps extends CommonProps {
  stroke?: string;
  width?: string | number | undefined;
  height?: string | number | undefined;
  inactive?: boolean;
}
const AiChatSendIcon: React.FC<IProps> = ({
  classes,
  stroke,
  width,
  height,
  inactive,
}) => {
  return inactive ? (
    <svg
      width={width || "32"}
      height={height || "32"}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="6.10352e-05"
        width="32"
        height="31.9999"
        rx="15.9999"
        fill="#B5E5CC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.8338 15.3043L9.9763 7.10607C9.36505 6.76857 8.63005 7.28682 8.76655 7.95732L9.95005 13.7548C10.016 14.0758 10.2763 14.3263 10.607 14.3848L18.6793 15.6051C19.142 15.6748 19.142 16.3251 18.6793 16.3948L10.607 17.6151C10.2763 17.6736 10.016 17.9241 9.95005 18.2451L8.76655 24.0426C8.63005 24.7138 9.36505 25.2313 9.9763 24.8938L24.8338 16.6956C25.3888 16.3896 25.3888 15.6111 24.8338 15.3043Z"
        fill="white"
      />
    </svg>
  ) : (
    <svg
      width={width || "32"}
      height={height || "32"}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.00012207"
        width="32"
        height="31.9999"
        rx="15.9999"
        fill="#25C16F"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.8338 15.3044L9.9763 7.10613C9.36505 6.76863 8.63005 7.28688 8.76655 7.95738L9.95005 13.7549C10.016 14.0759 10.2763 14.3264 10.607 14.3849L18.6793 15.6051C19.142 15.6749 19.142 16.3251 18.6793 16.3949L10.607 17.6151C10.2763 17.6736 10.016 17.9241 9.95005 18.2451L8.76655 24.0426C8.63005 24.7139 9.36505 25.2314 9.9763 24.8939L24.8338 16.6956C25.3888 16.3896 25.3888 15.6111 24.8338 15.3044Z"
        fill="white"
      />
    </svg>
  );
};

export default AiChatSendIcon;
